<template>
	<div
		id="pllentyForm"
		class="p-fluid p-p-2 p-ai-center"
		style="max-width: 1040px; margin: 0 auto"
	>
		<StepHeader class="p-mb-4" :currentStep="currentStep" :steps="steps" />
		<!-- TODO: figure out the v-show bug for first step :( -->
		<Membership
			v-show="currentStep === 0"
			:loadDonationParams="store.formParams"
			@nextStep="nextStep"
		/>

		<ProgramSelection
			v-show="currentStep === 1"
			@nextStep="nextStep"
			@prevStep="prevStep"
		/>

		<Waivers
			v-show="currentStep === 2"
			@nextStep="nextStep"
			@prevStep="prevStep"
		/>

		<ParentInformation
			v-show="currentStep === 3"
			@nextStep="nextStep"
			@prevStep="prevStep"
		/>

		<Confirm
			v-show="currentStep === 4"
			@formSubmitted="validateFormSubmission"
			@prevStep="prevStep"
		/>

		<EndForm v-show="currentStep === 5" />

		<div
			class="p-d-flex p-flex-column p-ai-center p-mt-5 pllenty-footer"
			aria-label="Pllenty footer content"
			role="contentinfo"
		>
			<div style="margin-bottom: -3px">
				<a
					href="https://pllenty.com/"
					target="_blank"
					aria-label="Pllenty wesbite, opens a new window"
				>
					<img
						:src="getImgUrl('pllenty-signature-115.gif')"
						alt="Powered by Pllenty"
						style="max-height: 50px"
					/>
				</a>
			</div>

			<small>
				This site is protected by reCAPTCHA and the Google
				<a
					href="https://policies.google.com/privacy"
					target="_blank"
					aria-label="Privacy Policy, opens a new window"
					class="p-primary-color"
					style="display: inline-flex !important"
				>
					Privacy Policy
				</a>
				and
				<a
					href="https://policies.google.com/terms"
					target="_blank"
					aria-label="Terms of Service, opens a new window"
					class="p-primary-color"
					style="display: inline-flex !important"
				>
					Terms of Service
				</a>
				apply.
			</small>
		</div>
	</div>
</template>

<script>
import { load } from "recaptcha-v3";

import { useFormDataStore } from "../store/formData.js";

import StepHeader from "../components/StepHeader.vue";
import Membership from "../components/FormSteps/Membership.vue";
import ProgramSelection from "../components/FormSteps/ProgramSelection.vue";
import ParentInformation from "../components/FormSteps/ParentInformation.vue";
// import PaymentInformation from "../components/FormSteps/PaymentInformation.vue";
import Confirm from "../components/FormSteps/Confirm.vue";
import Waivers from "../components/FormSteps/Waivers.vue";
import EndForm from "../components/FormSteps/EndForm.vue";

export default {
	name: "App",
	data() {
		return {
			currentStep: 0,
			steps: [
				{
					label: "Membership",
					to: "/",
				},
				{
					label: "Program Selection",
					to: "/2",
				},
				{
					label: "Waivers",
					to: "/3",
				},
				{
					label: "Parent Information",
					to: "/4",
				},
				{
					label: "Verify and Pay",
					to: "/5",
				},
				{
					label: "Thank You",
					to: "/6",
				},
			],
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			store,
		};
	},
	components: {
		StepHeader,
		Membership,
		ProgramSelection,
		ParentInformation,
		Confirm,
		Waivers,
		EndForm,
	},
	props: {
		formName: {
			type: String,
			default: "",
		},
		testMode: {
			type: Boolean,
		},
	},
	mounted() {
		this.loadRecaptcha();

		this.store.testMode = this.testMode;

		if (this.formName) {
			this.store.formName = this.formName;
		} else {
			this.store.formName = "";
		}
	},
	methods: {
		nextStep() {
			this.currentStep++;

			this.scrollToHeader();
		},
		prevStep() {
			this.currentStep--;

			this.scrollToHeader();
		},
		validateFormSubmission() {
			if (this.store.formSubmissionData.status === "Declined") {
				this.scrollToHeader();
			} else {
				this.nextStep();
			}
		},
		async loadRecaptcha() {
			const recaptcha = await load(this.store.recaptchaSiteKey, {
				autoHideBadge: true,
			});
			this.store.recaptchaObject = recaptcha;
		},
		scrollToHeader() {
			this.$nextTick(() => {
				if (document.getElementById("pllentyForm")) {
					let domRect = document
						.getElementById("pllentyForm")
						.getBoundingClientRect();

					window.scrollTo({
						left: domRect.left + document.documentElement.scrollLeft,
						top: domRect.top + document.documentElement.scrollTop - 10,
						behavior: "smooth",
					});
				}
			});
		},
		getImgUrl(imgName) {
			if (process.env.NODE_ENV === "development") {
				return require("../../public/img/" + imgName);
			} else {
				return "https://girlsinc-p2p.pllenty.com/logos/" + imgName;
			}
		},
	},
};
</script>

<style lang="scss">
.pllenty-footer a {
	background-color: transparent !important;
	font-size: revert !important;
	padding: 0 !important;
	line-height: 0 !important;
	text-decoration: none !important;
	text-transform: none !important;
}

.pllenty-footer span {
	color: initial !important;
}
</style>
